import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { FormService } from '../../services/form.service';
import { Validators } from '@angular/forms'
import { AppService } from 'src/app/app.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';


@Component({
    selector: 'app-form-field-dropdown',
    templateUrl: './form-field-dropdown.component.html',
    styleUrls: ['./form-field-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDropDownComponent implements OnInit {

  @Input() configData: typeDHLFormControls;
  @Input() frmGroup: UntypedFormGroup;

  dropDownListItems;

  constructor(private formService: FormService, private appService:AppService) { }


  //selected = '';
  compare(val1, val2) {
    if (val1 !== null && val2 !== null)
      return val1.value === val2.value;
  }
  ngOnInit() {
    if (this.configData['editable'] === false) {
      this.frmGroup.get(this.configData.name).disable();
    }
    this.dropDownListItems = this.configData.options;

    this.configData.validation.forEach(element => {
      if (element === 'hidden') {
        this.frmGroup.get(this.configData.name)['hidden'] = true;
      }
    }, this);

    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'INIT');
    if (event) {
      this.sendToSource(event, null);
      return
    }

    if (this.configData['affectedColumns']) {
      this.configData['affectedColumns'].forEach(element => {
        console.log(this.frmGroup.get(this.configData.name));
        let multipleValue;
        let multipleKey;
        if(element.multipleValue && element.multipleKey){
          multipleValue = element.multipleValue;
          multipleKey = element.multipleKey;
        } else {
          multipleValue = element.value;
          multipleKey = element.key;
        }
        if(element.type == "pattern"){
          if(this.frmGroup.get(this.configData.name).value){
            if (multipleKey === this.frmGroup.get(this.configData.name).value.value) {
              multipleValue.forEach(field => {
                if (!field.keepValue) {
                  this.frmGroup.get(field.name).updateValueAndValidity();
                }
              });
             }
          }
        }else if (this.frmGroup.get(this.configData.name).value.value === 'Vendor') {
          multipleValue.forEach(field => {
            this.frmGroup.get(field)['hidden'] = false;
            this.frmGroup.get(field).setErrors({ required: true });
          })
        }
      });
    }
    if (this.frmGroup.get(this.configData.name).value) {
      let control = this.frmGroup.get(this.configData.name);
      let name = this.configData.name;
      if (this.configData['relatedColumns']) {
        this.configData['relatedColumns'].forEach(element => {
          // if()
          if (element.key === control.value.value) {
            let fieldEvent = [];
            element.value.forEach(field => {
              fieldEvent.push(field);
            })
            // "keepvalue" should be true other wise relatedColumns will be empty while loading from "refineSearch"
            this.formService.setEvent({ 'visibility': true, 'name': name, 'eventList': fieldEvent, keepValue:true });
          }
        });
      }
    }

  }

  manageDropdown(e, data) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'CHANGE');
    if (event) {
      this.sendToSource(event, data);
      return
    }
    let name = this.configData.name;
    if (this.configData['relatedColumns']) {
      this.configData['relatedColumns'].forEach(element => {
        if (element.key === data.value) {
          let fieldEvent = [];
          element.value.forEach(field => {
            fieldEvent.push(field);
          })
          this.formService.setEvent({ 'visibility': true, 'name': name, 'eventList': fieldEvent, keepValue:false });
        }
      });
    }
    if (this.configData['affectedColumns']) {
      this.configData['affectedColumns'].forEach(element => {
        let elementValue;
        let elementKey;
        if(element.multipleValue && element.multipleKey){
          elementValue = element.multipleValue;
          elementKey = element.multipleKey;
        } else {
          elementValue = element.value;
          elementKey = element.key;
        }
        if(element.type == "pattern"){
        if (elementKey === data.value) {
          elementValue.forEach(field => {
              if (!field.keepValue) {
                this.frmGroup.get(field.name).updateValueAndValidity();
              }
            });
           }
        }else if (elementKey === data.value) {
          elementValue.forEach(field => {
            let fieldName = (typeof field == 'object' ? field.name : field);
            this.frmGroup.get(fieldName)['hidden'] = false;
            this.frmGroup.get(fieldName).setValidators([Validators.required]);
            this.frmGroup.get(fieldName).updateValueAndValidity();
          })
        } else {
          elementValue.forEach(field => {
            let fieldName = (typeof field == 'object' ? field.name : field);
            this.frmGroup.get(fieldName)['hidden'] = true;
            this.frmGroup.get(fieldName).setValidators(null);
            this.frmGroup.get(fieldName).updateValueAndValidity();
            if (!field.keepValue) {
              this.frmGroup.get(fieldName).reset();
            }
          })
        }
      });
    }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, data = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: data,
    }
    this.appService._commonComponentSubject.next(eventData);
  }
}
